import { render, staticRenderFns } from "./avisolegal.vue?vue&type=template&id=279c638e"
import script from "./avisolegal.vue?vue&type=script&lang=js"
export * from "./avisolegal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports